import React, {SVGProps} from 'react';

export const IconArrow = React.memo((props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 19a1 1 0 0 1-.768-1.64l4.476-5.37-4.316-5.363a1 1 0 0 1 1.56-1.254l4.828 6a1 1 0 0 1-.011 1.267l-5 6a1 1 0 0 1-.77.36Z"
        fill="#0D1C2E"
      />
      <mask id="a" maskUnits="userSpaceOnUse" x="9" y="5" width="7" height="14">
        <path
          d="M10 19a1 1 0 0 1-.768-1.64l4.476-5.37-4.316-5.363a1 1 0 0 1 1.56-1.254l4.828 6a1 1 0 0 1-.011 1.267l-5 6a1 1 0 0 1-.77.36Z"
          fill="#fff"
        />
      </mask>
    </svg>
  );
});
